import { ListIdentifier } from '../../microsoft/sharepoint/list-identifier';

export class SharePointResourcesBaseModel {
  lists: ListIdentifier[];
}
